import { render, staticRenderFns } from "./PhoneTransfer.vue?vue&type=template&id=06cdc48f&"
import script from "./PhoneTransfer.vue?vue&type=script&lang=js&"
export * from "./PhoneTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports